import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { StationService } from '../../../service/station/station.service';
import { Station } from '../../../class/station';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
declare var google: any;

@Component({
  selector: 'app-station',
  templateUrl: './station.component.html',
  styleUrls: ['./station.component.scss']
})
export class StationComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoStation: Station;
    public station: Station;
    public msgs: Message[] = [];
    public options: any;
    public overlays: any[];
    public latitude: number;
    public longitude: number;
    public zoom: number;

    constructor(
        public stationService: StationService,
        private activatedRoute: ActivatedRoute,
        private mapsAPILoader: MapsAPILoader) {
    }

    ngOnInit() {
        if (this.infoStation.latitude && this.infoStation.longitude) {
            const lat = this.infoStation.latitude;
            const lng = this.infoStation.longitude;
            const position = {
                lat : lat,
                lng : lng
            };
            this.setPosition(position);
        }
    }

    private setPosition(position) {
        this.latitude = position.lat;
        this.longitude = position.lng;
        this.zoom = 17;
    }

    public addMarker(lat, lng, title) {
        this.longitude = lng;
        this.latitude = lat;
        this.overlays = [];
        this.overlays.push(
            new google.maps.Marker({
                position: {
                    lat: lat,
                    lng: lng
                }, title: title}
            )
        );
    }

    public cancelStation () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/stations/station/station.component.ts